import React from 'react';

const Home = () => (
  <div className="Home" style={{ paddingTop: '2rem' }}>
    <h1 style={{ paddingBottom: '1rem' }}>Welcome to our Page</h1>
    <div>
      <p className="paragraph">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Ab assumenda aut consequatur deleniti dolorum enim
        fugiat fugit illum inventore, iste itaque modi optio
        perspiciatis quae, quia quisquam sit unde veritatis.
      </p>
      <p className="paragraph">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Aliquam cum dolore numquam sapiente voluptatum! Ad
        aspernatur commodi doloribus est expedita facilis, fuga
        impedit neque nesciunt, officia quis sit suscipit
        voluptas?
      </p>
    </div>
  </div>
);
export default Home;
